





















































import { Component, Vue, Provide } from 'vue-property-decorator';
import { getRandomColor } from '@/helpers/color';
import Peer from 'peerjs';
import QrReader from './qrReader.vue';

@Component({
    components: {
        QrReader,
    },
})
export default class ColorSyncPeer extends Vue {
    @Provide() public color: string = '#333333';

    @Provide() public peerId: string = '';

    @Provide() public connectToID: string = '';

    @Provide() public isScanning = false;

    @Provide() public connection: Peer.DataConnection | null = null;

    private peer!: Peer;

    private mounted() {
        this.peer = new Peer();
        this.peer.on('open', (id) => {
            this.peerId = id;
        });
    }

    private beforeDestroy() {
        if (this.connection) {
            this.connection.close();
            this.connection = null;
        }
    }

    private randomColor() {
        if (this.connection) {
            this.connection.send({ color: getRandomColor() });
        }
    }

    private toggleConnection() {
        if (!this.connection) {
            this.setupConnection(this.peer.connect(this.connectToID));
        } else {
            this.connection.close();
            this.connection = null;
        }
    }

    private toggleScan() {
        this.isScanning = !this.isScanning;
    }

    private onQrData(data: string) {
        this.isScanning = false;
        this.setupConnection(this.peer.connect(data));
    }

    private setupConnection(connection: Peer.DataConnection) {
        this.connection = connection;

        connection.on('error', () => {
            this.connection = null;
        });

        connection.on('close', () => {
            this.connection = null;
        });

        connection.on('data', (data) => {
            if (data.color) {
                this.color = data.color;
            }
        });
    }
}
